import styled from "styled-components";
import { ReactComponent as CreateIc } from "assets/icons/create.svg";
import { Form } from "formik";

export const Container = styled.main`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 370px;

  margin-top: 50px;

  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.4375rem;
    font-weight: bold;
    text-align: left;
    line-height: 18px;
    margin-bottom: 12px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

export const Label = styled.span`
  color: #5e5e5e;
  svg {
    margin-left: -5px;
    margin-right: 4px;
  }
  margin-bottom: 22px;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;

  p {
    color: #5e5e5e;
    font-size: 0.9375rem;
    line-height: 26px;
    margin-bottom: 20px;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  button {
    margin-bottom: 20px;
  }
`;

export const DaySection = styled.section`
  margin-bottom: 30px;
  h1 {
    font-size: 0.8125rem;
    font-weight: bold;
    margin: 0;
    margin-bottom: 15px;
    color: black;
  }

  input {
    display: none;
    height: 0;
    width: 0;
  }

  label {
    height: 40px;
    width: 40px;
    font-size: 0.9375rem;

    border-radius: 3px;
    border: 1px solid #9a9a9a;

    color: #9a9a9a;
    text-align: center;
    vertical-align: center;

    display: flex;
    place-content: center;
    place-items: center;

    margin: 0;
    margin-right: 10px;

    position: relative;

    div {
      height: 13.42px;
      width: 13.42px;
      position: absolute;
      background-color: #0ece00;
      display: flex;
      place-content: center;
      place-items: center;
      border-radius: 100%;
      color: white;
      top: -6px;
      right: -6px;
      opacity: 0;
    }
  }

  div {
    display: flex;
  }

  input[type="radio"]:checked + label {
    color: white;
    border: 1px solid ${({ theme }) => theme.colors.lightBlue};
    background-color: ${({ theme }) => theme.colors.lightBlue};
    div {
      opacity: 1;
    }
  }
`;

export const MailSection = styled.section`
  margin-bottom: 28px;

  h1 {
    font-size: 0.8125rem;
    font-weight: bold;
    margin: 0;
    margin-bottom: 15px;
    color: black;
  }

  div {
    display: flex;
    flex-direction: row;

    input {
      height: 14px;
      width: 14px;
    }

    input[type="radio"]:after {
      height: 10px;
      width: 10px;
    }

    label {
      margin-left: 10px;
      margin-right: 29px;
      font-size: 0.8125rem;
      color: #4d565c;
      line-height: 16px;
      font-weight: 400;
    }
  }
`;

export const EmailSection = styled.section`
  label:first-child {
    margin-bottom: 20px;
  }

  margin-bottom: 30px;
`;

export const AutomaticDebtSection = styled.section`
  h1 {
    font-size: 0.8125rem;
    font-weight: bold;
    margin: 0;
    margin-bottom: 15px;
    color: black;
  }

  p {
    font-size: 0.8125rem;
    color: #5e5e5e;
    max-width: 274px;
  }
`;

export const HasEmailSection = styled.section`
  color: #5e5e5e;
  font-size: 0.9375rem;
  p {
    margin-bottom: 13px;
  }
`;

export const WarningSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #e7e6e6;
  color: #000;
  padding: 5px;
  margin-bottom: 30px;
  border-left: 5px solid #aeabab;
  border-radius: 5px;

  span {
    font-weight: 600;
    font-size: 16px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
`;

export const TermsSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  input {
    margin-right: 10px;
  }

  label {
    color: #4d565c;
    font-size: 0.8125rem;
    line-height: 16px;
    font-weight: 400;
  }

  a {
    cursor: pointer;
    font-size: 0.8125rem;
    line-height: 16px;
    font-weight: 400;
    text-decoration: none;
    color: #148ad9 !important;
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  span {
    color: #5e5e5e;
    font-size: 0.9375rem;
    text-align: left;
    line-height: 26px;
    margin-bottom: 22px;
    display: block;
  }
`;

export const Error = styled.span`
  color: #dc3545;
`;

export const EditIcon = styled(CreateIc)`
  margin-right: 6px;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 24px;
  height: 24px;
  width: 24px;
  path:nth-child(2) {
    fill: ${({ theme }) => theme.colors.gray};
  }
`;

export const EditAddressContainer = styled.button`
  margin-top: 20px;
  margin-bottom: 33px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  color: #757575;
  display: flex;
  flex-direction: row;
  place-items: center;
`;

export const AddressLabelModificated = styled.span`
  max-width: 171px;
  width: 100%;
  background-color: #ffb300;
  border-radius: 3px;
  padding: 4px 10px 4px 10px;
  font-size: 0.75rem;
  font-weight: 400;
  color: #fff;
  margin-bottom: 8px;
`;
